import React from 'react'
import GuPage from './Gu'

const Gu = () => (
  <GuPage/>
)

export default Gu
